export default "### 2021-06-14 - Hotfix v4.0.8 Galileo  \n---\n\nBugs Fixed  \n-   Event-transport connection churn should be reduced\n"